module.exports = __webpack_public_path__ + "9713e8ef4a03450525d20d58288b5a2a.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img12.png
// module id = 1318
// module chunks = 0